import { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthProvider';
import { supabase } from '../lib/supabase';

/**
 * Concelho slugs the current user can watch in the fire nowcast, via the
 * my_nowcast_zones RPC (briefing_subscriptions zone rows gated by the
 * 'nowcast' feature grant — see sql/supabase/0004_nowcast.sql). `zones` is
 * null while loading, then a (possibly empty) list. Not logged in or auth
 * unconfigured → [].
 */
export function useNowcastZones() {
  const { user, loading: authLoading, configured } = useAuth();
  const [zones, setZones] = useState<string[] | null>(null);

  useEffect(() => {
    if (authLoading) return;
    if (!configured || !user) {
      setZones([]);
      return;
    }
    let cancelled = false;
    setZones(null);
    supabase.rpc('my_nowcast_zones').then(({ data, error }) => {
      if (cancelled) return;
      if (error || !Array.isArray(data)) {
        setZones([]);
        return;
      }
      setZones(
        data
          .map((row: { concelho_slug?: string } | string) =>
            typeof row === 'string' ? row : (row.concelho_slug ?? ''),
          )
          .filter(Boolean),
      );
    });
    return () => {
      cancelled = true;
    };
  }, [user, configured, authLoading]);

  return { zones, loading: authLoading || zones === null };
}
